import { ReactNode } from "react";
import usePopover from "components/hooks/usePopover";
import { IconButton, Popover, Tooltip } from "@mui/material";
import { History } from "@mui/icons-material";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";

type LastShippedProductsPopoverProps = {
	lastShippedProducts: string[];
	children: ReactNode;
}

const LastShippedProductsPopover = ({ lastShippedProducts, children } : LastShippedProductsPopoverProps) => {
	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (lastShippedProducts == null || lastShippedProducts.length === 0) {
		return <>{children}</>;
	}

	return <>
		{children}
		<Tooltip placement="bottom" title={intl.formatMessage({ id: "LAST_SHIPPED_PRODUCTS" })}>
			<IconButton size="small" onClick={onPopoverOpen} style={{ padding: 0 }}>
				<History style={{ fontSize: 16 }} />
			</IconButton>
		</Tooltip>
		<Popover {...popoverProps}>
			<div style={{ padding: 16 }}>
				{lastShippedProducts.map((product, i) => (
					<FormGroup labelPlacement="top" labelWidth={240} label={intl.formatMessage({ id: `LAST_PRODUCT_${i + 1}` })}>
						<span style={{ whiteSpace: "pre-wrap" }}>{product}</span>
					</FormGroup>
				))}
			</div>
		</Popover>
	</>;
};

export default LastShippedProductsPopover;
